import React from 'react'
import { cls } from '../../utils/helpers.js'

export type ErrorBannerTone = 'error' | 'warning' | 'warn' | 'info'

export interface ErrorBannerProps extends React.HTMLAttributes<HTMLDivElement> {
  tone?: ErrorBannerTone
}

// Announced form/page-level error. Renders nothing when `children` is falsy
// so it's a drop-in replacement for the `{error && <div…>}` pattern.
// role="alert" + aria-live="assertive" make screen readers announce it the
// moment it mounts, which is the whole point (§8.10).
export function ErrorBanner({ children, className, tone = 'error', ...props }: ErrorBannerProps) {
  if (!children) return null
  return (
    <div
      className={cls('error-banner', `error-banner-${tone}`, className)}
      role="alert"
      aria-live="assertive"
      {...props}
    >
      {children}
    </div>
  )
}
